export class Currency {
  constructor(last, buy, sell, symbol) {
    this.last = last;
    this.buy = buy;
    this.sell = sell;
    this.symbol = symbol;
  }
}
